module.exports = "//static.hsappstatic.net/growth-data-modal/static-1.2445/images/google-contacts.svg"